import React from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../shared/hooks/use-app-selector';
import { Alert, Button, Flex, Typography } from 'antd';

import { t } from '../../../utils/i18n';
import { useGlobals } from '@shared/contexts/GlobalsContext';
import { changeLocation } from '../../../actions';
import EVENT_BUS_EVENTS from '../../../constants/event-bus-events';

export function TrialDaysNotification() {
  const currentMerchant = useAppSelector((state) => state.currentMerchant);
  const { subscriptionActivationAllowed } = currentMerchant;

  const dispatch = useDispatch();
  const { eventBus, trackMethod } = useGlobals();
  const trialDaysLeft = useAppSelector(
    (state) => state.currentMerchant.trialDaysLeft
  );

  const handleOnUpgradeNowButtonClick = () => {
    const route = '/settings/subscription';
    trackMethod('action_notification_banner_button_clicked', {
      platform: 'booking',
      location: 'top_menu_notification',
      button_type: 'upgrade_now',
    });
    dispatch(changeLocation(route));
    eventBus?.emit(EVENT_BUS_EVENTS.NAVIGATE, { payload: { route } });
  };

  if (!trialDaysLeft) return null;

  const isLateTrial = trialDaysLeft <= 4;

  const normalTrialMessage = isLateTrial
    ? t('trial-days-notification.trial-late.message', {
        days: trialDaysLeft,
      })
    : t('trial-days-notification.trial-early.message', {
        days: trialDaysLeft,
      });

  const extendedTrialToSubscriptionMessage = t(
    'trial-days-notification.trial-extended-to-subscription.message',
    {
      days: trialDaysLeft,
    }
  );

  const buttonText = isLateTrial
    ? t('trial-days-notification.trial-late.cta-button')
    : t('trial-days-notification.trial-early.cta-button');

  const alertStyle = {
    backgroundColor:
      isLateTrial && subscriptionActivationAllowed ? '#fff8e1' : '#e8f8f6',
  };
  const textStyle = {
    color: isLateTrial && subscriptionActivationAllowed ? '#e65100' : '#1a1a1a',
  };
  const buttonStyle = {
    backgroundColor:
      isLateTrial && subscriptionActivationAllowed ? '#FF9800' : '#2BBFB3',
    borderColor:
      isLateTrial && subscriptionActivationAllowed ? '#FF9800' : '#2BBFB3',
  };

  return (
    <Alert
      banner
      closable
      type="info"
      showIcon={false}
      style={alertStyle}
      data-testid="trial-days-notification"
      message={
        subscriptionActivationAllowed ? (
          <Flex gap={16} justify="center" align="center">
            <Typography.Text style={textStyle}>
              {normalTrialMessage}
            </Typography.Text>
            <Button
              danger
              size="small"
              color="primary"
              variant="solid"
              style={buttonStyle}
              onClick={handleOnUpgradeNowButtonClick}
            >
              {buttonText}
            </Button>
          </Flex>
        ) : (
          <Flex gap={16} justify="center" align="center">
            <Typography.Text style={textStyle}>
              {extendedTrialToSubscriptionMessage}
            </Typography.Text>
          </Flex>
        )
      }
    />
  );
}
